export const localization = {
  pt: {
    locale: 'pt-BR',
    name: 'Descrição',
    expiration: 'Expiração',
    status: 'Status',
    actions: 'Ações',
    title: 'Certificados MTLS',
    subtitle: 'Listagem de certificados MTLS',
    hostsModalTitle: 'Hosts do certificado',
    validationStatus: {
      valid: 'Válido',
      invalid: 'Inválido',
      underValidation: 'Em validação',
    },
    errorToast: 'Erro ao carregar certificados MTLS',
  },
  en: {
    locale: 'en-US',
    name: 'Description',
    expiration: 'Expiration',
    status: 'Status',
    actions: 'Actions',
    title: 'MTLS Certificates',
    subtitle: 'MTLS certificates listing',
    hostsModalTitle: 'Certificate hosts',
    validationStatus: {
      valid: 'Valid',
      invalid: 'Invalid',
      underValidation: 'Under validation',
    },
    errorToast: 'Error loading MTLS certificates',
  },
  es: {
    locale: 'es-ES',
    name: 'Descripción',
    expiration: 'Vencimiento',
    status: 'Estado',
    actions: 'Acciones',
    title: 'Certificados MTLS',
    subtitle: 'Listado de certificados MTLS',
    hostsModalTitle: 'Hosts del certificado',
    validationStatus: {
      valid: 'Válido',
      invalid: 'Inválido',
      underValidation: 'En validación',
    },
    errorToast: 'Error al cargar certificados MTLS',
  },
};
